import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import * as SpeechSDK from 'microsoft-cognitiveservices-speech-sdk';
@Injectable({
    providedIn: 'root'
  })
  export class SpeechRecognitionService {
    private _recognizer!: SpeechSDK.SpeechRecognizer;
    private _speechConfig!: SpeechSDK.SpeechTranslationConfig;
    private _audioConfig!: SpeechSDK.AudioConfig;
    hasRecognitionStarted = false;
    speechRecognitionResult = new Subject<any>();
    speechRecognitionLanguage: string = 'es-ES';
  
    constructor() { }
  
    initRecognition() {
      this._audioConfig = SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();
      this._speechConfig = SpeechSDK.SpeechTranslationConfig.fromSubscription("33bb80d2f6344eb3b3e43a3c3abd571d", "westeurope");
      this._speechConfig.speechRecognitionLanguage = this.speechRecognitionLanguage;
      this._speechConfig.enableDictation();
      this._recognizer = new SpeechSDK.SpeechRecognizer(this._speechConfig, this._audioConfig);
  
      this._recognizer.recognized = (s, e) => this.handleRecognizedResponse(s, e);
      this._recognizer.canceled = (s, e: any) => this.handleCanceled(e);
    }
  
    startContinuousRecognition() {
      try {
        this._recognizer.startContinuousRecognitionAsync(() => {
          this.hasRecognitionStarted = true;
        });
      } catch (e) {
        console.error('Error', e);
      }
    }
  
    stopRecognition() {
      if (!this._recognizer) return;
      this._recognizer.stopContinuousRecognitionAsync(() => {
        this._recognizer.close();
        this.hasRecognitionStarted = false;
      });
    }
  
    private handleRecognizedResponse(s: any, e: any) {
      // Emit only if text is not empty and is final
      if (e.result && e.result.text && e.result.reason === 3) { // 3 = RecognizedSpeech
        this.speechRecognitionResult.next({ isFinal: true, result: e.result.text });
      }
    }
  
    private handleCanceled(e: any) {
      console.error("Error", e);
    }
  }
